'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var $ = require("jquery");
var Scroll = /** @class */ (function () {
    function Scroll() {
        this.adjustMenu();
    }
    Scroll.prototype.adjustMenu = function () {
        $(window).on('load scroll', function () {
            var scroll = $(window).scrollTop();
            if (scroll < 80) {
                $('.bulletPcNavi').attr('data-is-fixed', 'false');
            }
            else {
                $('.bulletPcNavi').attr('data-is-fixed', 'true');
            }
        });
    };
    return Scroll;
}());
exports.Scroll = Scroll;
exports.default = Scroll;
